import { render, staticRenderFns } from "./HandIdCard.vue?vue&type=template&id=c92af4d6&"
import script from "./HandIdCard.vue?vue&type=script&lang=js&"
export * from "./HandIdCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports